import { render, staticRenderFns } from "./Conto_lavoro.vue?vue&type=template&id=39eda8c8&"
import script from "./Conto_lavoro.vue?vue&type=script&lang=js&"
export * from "./Conto_lavoro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports